module.exports = __webpack_public_path__ + "static/media/gift.b69bb8e4.svg";